/**
 * Diese Komponente bindet dann das jeweilige Modul ein, übergibt den User, sowie die verfügbaren Socialmediakanäle und die jeweiligen Pfade und Token.
 */

import 'regenerator-runtime/runtime'
import React from 'react'
import { createStore, applyMiddleware } from 'redux'
import { Provider, useSelector } from 'react-redux'
import createSagaMiddleware from 'redux-saga'
import { composeWithDevTools } from '@redux-devtools/extension'
// import { UserLogin } from '@professocialApi/professocial-core-frontend-api'
import { getTheme } from '../../../store/common/common.selectors'
import { Grid, Theme } from '@mui/material'

// Topics
import ProfessocialTopics from '@professocial/professocialTopics/src/screens/ProfessocialTopics'
import { topicRootReducer } from '@professocial/professocialTopics/src/store/topicRoot.reducer'
import { topicRootSagas } from '@professocial/professocialTopics/src/store/topicRoot.sagas'
import { DisplayMode } from '@professocial/professocialTypes/types/commonTypes'

// Topics
const sagaMiddleware = createSagaMiddleware()
const storeTopics = createStore(
  topicRootReducer,
  composeWithDevTools(
    applyMiddleware(sagaMiddleware),
  ),
)
sagaMiddleware.run(topicRootSagas)

const EditorTopics: React.FC = () => {
  const theme: Theme = useSelector(getTheme)

  return (
    <Grid container spacing={2} sx={{ px: 2, pb: 10, mt: 1 }}>
      <Grid item xs={12}>
        <Provider store={storeTopics}>
          <ProfessocialTopics
            topicConfiguration={{
              theme,
              initialValueDropdown: true,
              integrateImages: true,
              editMode: DisplayMode.newScreen,
              editable: true,
            }}
          />
        </Provider>
      </Grid>
    </Grid>
  )
}
export default EditorTopics
